import { routeFactory } from "@/RouteFactory";
import { Crumb } from "@/components/bread-crumbs/Crumb";
import { PageHeader } from "@/components/page-header/PageHeader";
import { testIdConstants } from "@/types/test-id-constants/testIdConstants";
import { BreadCrumbs, stenaDetails } from "@stenajs-webui/elements";
import * as React from "react";

interface Props {
  customer:
    | {
        id: string;
        breadCrumbName: string;
      }
    | null
    | undefined;
}

export const DocumentsHeader: React.FC<Props> = ({ customer }) => {
  return (
    <PageHeader
      title={"Documents"}
      icon={stenaDetails}
      breadcrumbs={
        <BreadCrumbs>
          <Crumb
            label={customer?.breadCrumbName ?? ""}
            path={routeFactory.productAndPrice.customer.customer({
              customerId: customer?.id ?? "",
            })}
            dataTestid={testIdConstants.breadcrumbCustomer}
          />
          <Crumb label={"Documents"} />
        </BreadCrumbs>
      }
    />
  );
};
